// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__SZn_i","errorLogs":"EditorFooter_errorLogs__1dO0A"};